import AWS from "aws-sdk";

export const cognitoIdp = new AWS.CognitoIdentityServiceProvider({
  region: process.env.REACT_APP_AWS_REGION,
  apiVersion: process.env.REACT_APP_AWS_API_VERSION,
});

// export default new CognitoUserPool(poolData);
